
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Onesevanseater() {



  const cardData =
  {
    keyword: ' 17 Seater Force Urbania on Rent in Pune',
    heading: 'Vaishnavi Travels: 17 Seater Force Urbania on Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers convenient and affordable 17 Seater Force Urbania on Rent in Pune, ideal for weddings, corporate outings, school tours, family functions, and long-distance travel. Our Force Urbania is well-maintained with spacious push-back seating, modern interiors, powerful air-conditioning, and ample luggage space to provide maximum comfort for every passenger. With professional chauffeurs, punctual service, and flexible booking options, we ensure smooth and hassle-free group travel. Whether it’s a religious yatra, weekend picnic, or business trip, Vaishnavi Travels guarantees safe, reliable, and comfortable 17 seater Force Urbania rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],

"services": [
  {
    "name": "17 Seater Urbania Hire Pune",
    "description": "Book a 17 seater Urbania van in Pune for seamless group travel across the city or to outstation locations. Perfect for mid-sized groups, this vehicle offers enhanced space, cushioned pushback seats, and high roof clearance for a relaxed travel experience. Whether it’s a pilgrimage, corporate retreat, wedding transport, or leisure tour, this van delivers both reliability and style. Equipped with power windows, efficient AC, LED lighting, and driver intercom for smooth communication, it's ideal for both day and night travel requirements."
  },
  {
    "name": "AC Urbania 17 Seater Rental",
    "description": "Experience travel in cool comfort with our air-conditioned 17 seater Urbania rental service in Pune. These vans are tailored for summer trips, long drives, and all-day events where comfort is key. Each seat is ergonomically designed, with independent AC vents, armrests, and reading lights. Ideal for corporate trips, airport pickups, and sightseeing tours. With excellent suspension and reduced cabin noise, it ensures a peaceful and enjoyable journey for passengers across age groups."
  },
  {
    "name": "Wedding Urbania 17 Seater Pune",
    "description": "Ensure premium transport for your wedding guests with our 17 seater Urbania van service in Pune. Ideal for moving family members, relatives, or VIP guests between wedding venues, this van offers luxury, punctuality, and a festive touch. Decoration options, soft music, and uniformed drivers make the experience more elegant. Available on a per-event or full-day rental basis, making it perfect for Sangeet, Haldi, wedding day, or reception logistics."
  },
  {
    "name": "Force Urbania 17 Seater Van Hire",
    "description": "Hire the top-rated Force Urbania 17 seater van in Pune for ultimate travel convenience. Built for Indian roads, this van features superior build quality, stylish interiors, and high ground clearance. It is ideal for tourism operators, family travel, and school tours looking for both comfort and durability. The vehicle comes equipped with GPS tracking, music system, tinted windows, and experienced drivers. Daily, hourly, and multi-day packages available at competitive rates."
  },
  {
    "name": "17 Seater Outstation Urbania Pune",
    "description": "Travel beyond Pune with ease using our 17 seater Urbania outstation rental. Whether you’re heading to Mahabaleshwar, Shirdi, Lonavala, or Goa, this vehicle handles long distances with comfort. With ample legroom, reclining seats, powerful AC, and secure luggage space, the van keeps all passengers refreshed during the journey. Includes driver, fuel options, and trip coordination support. Ideal for religious groups, office outings, and family vacations."
  },
  {
    "name": "Corporate 17 Seater Urbania Rental",
    "description": "Professional and punctual 17 seater Urbania vans available for corporate use in Pune. Suitable for seminars, conferences, team offsites, airport drops, and client meetings. Comes with clean interiors, courteous drivers, and branding options. Wi-Fi, charging ports, and reading lights available in select models. Daily and monthly rental contracts supported for recurring transport needs. Impress clients and keep employees comfortable on the move."
  },
  {
    "name": "Urbania 17 Seater for Family Trip",
    "description": "Plan your next family adventure in comfort with a 17 seater Urbania van. Whether you're visiting temples, hill stations, or tourist attractions around Pune, this vehicle keeps everyone together and relaxed. With a high ceiling, wide aisles, individual AC vents, and safety locks, it’s suitable for all ages. It also comes with extra luggage storage and music system to make long drives more enjoyable. Drivers are trained for family travel safety and courteous behavior."
  },
  {
    "name": "Weekend Travel Urbania Pune",
    "description": "Make your weekend getaway smooth with our Urbania 17 seater weekend packages from Pune. Explore popular destinations like Lonavala, Matheran, Alibaug, or Panchgani with your group in one comfortable van. Book for one or two days with options for early morning departures, multiple pick-up points, and scenic stopovers. A great alternative to taking multiple vehicles or crowded buses. Fuel, toll, and driver allowance options are bundled for convenience."
  },
  {
    "name": "Luxury 17 Seater Van Hire Pune",
    "description": "For premium experiences, book our luxury 17 seater Urbania vans with leather-finished interiors, soundproofing, ambient lighting, and deluxe seat spacing. These vans are perfect for VIP movement, high-end tourism, business events, and executive travel. Features include chilled water bottles, phone chargers, LED screens, and top-tier air conditioning. Available on demand with multilingual drivers and premium customer support services."
  },
  {
    "name": "Pune Darshan 17 Seater Urbania",
    "description": "Explore Pune's rich heritage and attractions with our 17 seater Urbania vans designed for sightseeing. Visit Shaniwar Wada, Aga Khan Palace, Parvati Hill, Saras Baug, and more in a vehicle that offers panoramic windows, a tour guide option, and multiple short halts. Best suited for school groups, tourist families, and local visitors who want a convenient and organized Pune Darshan experience."
  },
  {
    "name": "School Trip 17 Seater Van",
    "description": "Ensure child safety and comfort on school field trips with our 17 seater Urbania vans in Pune. Features include seatbelts, safety locks, first aid kit, and driver background verification. Perfect for small group educational tours, science exhibitions, or inter-school competitions. Each trip is monitored for punctuality and comes with real-time tracking if required. Teachers and staff can travel comfortably alongside students in this mid-size vehicle."
  },
  {
    "name": "Driver-Included Urbania 17 Seater",
    "description": "Hire a fully maintained 17 seater Urbania van in Pune with an experienced driver included in the package. All drivers are familiar with city and highway routes and adhere to safety and customer service standards. The service includes fuel options, route customization, and 24/7 customer support. Ideal for those who want a worry-free transport solution for weddings, tours, or office travel without handling logistics."
  },
  {
    "name": "Group Booking 17 Seater Urbania",
    "description": "Make travel planning easy with group booking for our 17 seater Urbania vans in Pune. Whether you're a travel agency, school, or corporate event organizer, we offer discounted group rates, multiple van dispatch, and centralized booking support. Each van is sanitized, GPS-enabled, and comes with standard travel amenities. Useful for tours, conferences, pilgrimage trips, and social gatherings requiring coordinated transport solutions."
  }
],
"tableData": [
  ["17 Seater Urbania Hire Pune", "AC Urbania 17 Seater Rental"],
  ["Wedding Urbania 17 Seater Pune", "Force Urbania 17 Seater Van Hire"],
  ["17 Seater Outstation Urbania Pune", "Corporate 17 Seater Urbania Rental"],
  ["Urbania 17 Seater for Family Trip", "Weekend Travel Urbania Pune"],
  ["Luxury 17 Seater Van Hire Pune", "Pune Darshan 17 Seater Urbania"],
  ["School Trip 17 Seater Van", "Driver-Included Urbania 17 Seater"],
  ["Group Booking 17 Seater Urbania"]
],




"whychoose": [
  {
    "WhyChooseheading": "17 Seater Force Urbania on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels provides premium 17-seater Force Urbania rentals in Pune — perfect for luxury group travel, corporate events, weddings, and outstation tours."
  },
  {
    "WhyChooseheading": "Spacious and Modern Interiors",
    "WhyChoosedescription": "The 17-seater Urbania offers plush pushback seats, wide legroom, air conditioning, and premium interiors for a first-class travel experience."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced and sanitized before every trip to ensure cleanliness, safety, and a worry-free journey."
  },
  {
    "WhyChooseheading": "Ideal for Local and Outstation Trips",
    "WhyChoosedescription": "Suitable for family outings, group tours, corporate travel, religious trips, and more — in Pune and across Maharashtra."
  },
  {
    "WhyChooseheading": "Professional and Experienced Chauffeurs",
    "WhyChoosedescription": "Our skilled drivers are courteous and trained to provide a smooth, safe, and timely journey on all routes."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, full-day, or multi-day rental plans tailored to your schedule and destination."
  },
  {
    "WhyChooseheading": "Transparent Pricing — No Hidden Charges",
    "WhyChoosedescription": "Our all-inclusive pricing includes fuel, tolls, taxes, and driver allowance to avoid any surprises."
  },
  {
    "WhyChooseheading": "24/7 Support and Easy Booking",
    "WhyChoosedescription": "Our dedicated customer support team is available 24/7 to help with bookings, updates, and assistance during your trip."
  }
]


















  }






const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 17 seater Force Urbania on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides 17 seater Force Urbania vehicles on rent in Pune, ideal for medium-sized groups, corporate travel, and family trips.',
    },
    {
      question: 'What are the features of the 17 seater Force Urbania?',
      answer: 'The 17 seater Force Urbania offers spacious seating, air-conditioning, comfortable legroom, and modern interiors designed for a smooth and pleasant journey.',
    },
    {
      question: 'Are these vehicles well-maintained and driven by professional drivers?',
      answer: 'Absolutely! All our Force Urbania vehicles are regularly serviced and maintained. Rentals include experienced, licensed, and courteous drivers to ensure safety and comfort.',
    },
    {
      question: 'What is the approximate rental cost for a 17 seater Force Urbania in Pune?',
      answer: 'Rental prices typically start from ₹3,800 for half-day local trips. Pricing depends on duration, distance, and any additional services requested.',
    },
    {
      question: 'Can I book the 17 seater Force Urbania for outstation trips?',
      answer: 'Yes, we offer outstation packages with transparent pricing for day trips, multi-day journeys, and long-distance travel.',
    },
    {
      question: 'How far in advance should I book the 17 seater Force Urbania?',
      answer: 'It is advisable to book at least 2-3 days in advance, especially during weekends and peak travel seasons, to ensure vehicle availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available?',
      answer: 'Yes, we provide flexible pickup and drop-off points within Pune and nearby locations to accommodate your travel needs.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Amit Kulkarni",
    position: "Team Lead, IT Firm",
    feedback:
      "We booked the 17 seater Force Urbania for a corporate outing. The vehicle was spacious, clean, and air-conditioned. The driver was punctual and professional, making our trip smooth and hassle-free.",
    rating: 5,
  },
  {
    name: "Ms. Neha Patil",
    position: "Event Organizer",
    feedback:
      "The 17 seater Force Urbania from Vaishnavi Travels was perfect for our family event. Comfortable seats, excellent AC, and a friendly driver made our journey enjoyable. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Force Urbania on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/17-seater-urbania-rental-pune.jpg",
  "description": "Rent 17 Seater Force Urbania in Pune from Vaishnavi Travels. Ideal for group travel, weddings, corporate trips, school tours & Pune Darshan. AC Urbania van with driver available for outstation and local use.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.86",
    "ratingCount": "495"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/17-seater-force-urbania-on-rent-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>17 Seater Force Urbania on Rent in Pune | AC Van for Group Travel | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent 17 Seater Force Urbania in Pune from Vaishnavi Travels. Ideal for group travel, weddings, corporate trips, school tours & Pune Darshan. AC Urbania van with driver available for outstation and local use."
  />
  <meta
    name="keywords"
    content="17 Seater Urbania Hire Pune, AC Urbania 17 Seater Rental, Wedding Urbania 17 Seater Pune, Force Urbania 17 Seater Van Hire, 17 Seater Outstation Urbania Pune, Corporate 17 Seater Urbania Rental, Urbania 17 Seater for Family Trip, Weekend Travel Urbania Pune, Luxury 17 Seater Van Hire Pune, Pune Darshan 17 Seater Urbania, School Trip 17 Seater Van, Driver-Included Urbania 17 Seater, Group Booking 17 Seater Urbania"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevanseater;